/* eslint id-length: 0 */
import { profileHash } from "PFCore/helpers/profile_hash";
import { UiRoute } from "PFCore/utilities/routes";
import footerPng from "PFImages/client/kpmg/KPMG_AU_CV_Footer.png";

import { getTranslationKey } from "../../../../helpers/custom_pptx_template";
import { splitLinesByContent } from "../../../helpers";
import { TextItem } from "../../../types";
import {
  createContacts,
  createCustomField,
  createPositions,
  createSummary,
  getSidebarCustomTypes
} from "./helpers";
import {
  avatarOptions,
  bodyOptions,
  customLogoOptions,
  defaultLogoOptions,
  footerOptions,
  getSidePanelDetailsOptions,
  header3Options,
  nameOptions,
  sidebarOptions
} from "./options";

export const localExportBuildKpmgAuPptx = (data, config, order, pptxgen, t, formatDate) => {
  const {
    id,
    avatar,
    contactInformationItems,
    email,
    _originalData: { internal_experiences: internalExperiences },
    customTypes,
    jobTitle,
    logo,
    name,
    positions,
    summary
  } = data;

  const pptx = new pptxgen();
  pptx.layout = "LAYOUT_WIDE";

  pptx.defineSlideMaster({
    title: "RESUME",
    background: { color: "FFFFFF" },
    objects: [
      {
        rect: sidebarOptions
      }
    ]
  });

  const allSlides = [pptx.addSlide({ masterName: "RESUME" })];
  const slide = allSlides[0];

  const getSlide = (index: number) => {
    const slide = allSlides[index];
    if (slide) {
      return slide;
    }

    const newSlide = pptx.addSlide({ masterName: "RESUME" });
    allSlides.push(newSlide);
    return newSlide;
  };

  const { templateKey, isBlindModeOn, hidden } = config;

  const translationKey = getTranslationKey(templateKey);

  const showAvatar = avatar && !isBlindModeOn;
  const showSummary = summary && order.includes("summary") && !hidden.summary;
  const showExperience = positions && order.includes("experience") && !hidden.positions;

  const sidebarCustomTypes = getSidebarCustomTypes(order, hidden, customTypes);

  // left column (sidebar)
  if (showAvatar) {
    slide.addImage({
      ...avatarOptions,
      data: avatar
    });
  }

  const leftDetailsTextArray: TextItem[] = [
    {
      text: isBlindModeOn ? `Candidate ${profileHash(id)}` : name,
      options: nameOptions
    }
  ];

  if (jobTitle) {
    leftDetailsTextArray.push({
      text: jobTitle,
      options: header3Options
    });
  }

  if (!isBlindModeOn) {
    leftDetailsTextArray.push(...createContacts(contactInformationItems, email, t, translationKey));
  }

  leftDetailsTextArray.push(...sidebarCustomTypes.map(createCustomField).flat());

  const sidePanelOptions = [getSidePanelDetailsOptions(showAvatar), getSidePanelDetailsOptions(false)];
  const linesPerSlide = splitLinesByContent(leftDetailsTextArray, ...sidePanelOptions);
  linesPerSlide.forEach((lines, index) =>
    getSlide(index).addText(lines, sidePanelOptions[index] || sidePanelOptions[-1])
  );

  // right panel
  const detailsTextArray: TextItem[] = [];

  if (showSummary) {
    detailsTextArray.push(...createSummary(summary, t(`${translationKey}.summary`)));
  }
  if (showExperience) {
    detailsTextArray.push(
      ...createPositions(positions, internalExperiences, t(`${translationKey}.positions`), formatDate, t)
    );
  }

  splitLinesByContent(detailsTextArray, bodyOptions).forEach((lines, index) =>
    getSlide(index).addText(lines || "", bodyOptions)
  );

  allSlides.forEach((slide) => {
    // logo
    const logoOptions = logo.custom
      ? { ...customLogoOptions, data: logo.url }
      : { ...defaultLogoOptions, path: logo.url };
    slide.addImage(logoOptions);

    slide.addImage({
      ...footerOptions,
      path: UiRoute(footerPng)
    });
  });

  return pptx;
};
